import { Skeleton } from '@linka/ui/skeleton';

export const FormSkeleton = () => {
  return (
    <div className='space-y-lg'>
      <div className='space-y-mini'>
        <Skeleton className='w-1/3 h-micro' />
        <Skeleton className='w-2/3 h-mini' />
        <Skeleton className='w-full h-xs' />
      </div>
      <div className='space-y-mini'>
        <Skeleton className='w-1/3 h-micro' />
        <Skeleton className='w-2/3 h-mini' />
        <Skeleton className='w-full h-xl' />
      </div>
      <div className='space-y-mini'>
        <Skeleton className='w-1/3 h-micro' />
        <Skeleton className='w-2/3 h-mini' />
        <Skeleton className='w-2/4 h-xs' />
      </div>
      <div className='space-y-mini'>
        <Skeleton className='w-1/3 h-micro' />
        <Skeleton className='w-2/3 h-mini' />
        <div className='flex items-center gap-micro'>
          <Skeleton className='w-2/4 h-xs' />
          <Skeleton className='w-2/4 h-xs' />
        </div>
      </div>
    </div>
  );
};
